/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import "./building-material-component.scss";
import { StaticAlert, CheckboxPart } from "components";

interface TypeOfRadioboxType {
  field: any;
  errors?: any;
  form: any;
  label: string;
  half: boolean;
  optional?: boolean;
  options: { label: string; value: string; uuid: string }[];
}

const TypeOfRadiobox = ({
  field,
  form,
  errors,
  label,
  options,
  half = false,
  optional,
}: TypeOfRadioboxType) => {
  const [buildingMaterialObject, setBuildingMaterialObject] = useState<
    string | string[]
  >(
    Array.isArray(field.name)
      ? field.name.filter((name: string) => form.values[name] === true)
      : form.values[field.name] || ""
  );

  const handleCheckMaterial = (item: any) => {
    if (Array.isArray(buildingMaterialObject)) {
      if (buildingMaterialObject.includes(item.value)) {
        setBuildingMaterialObject([]);
      } else {
        setBuildingMaterialObject([item.value]);
      }
    } else {
      if (buildingMaterialObject === item.value) {
        setBuildingMaterialObject("");
      } else {
        setBuildingMaterialObject(item.value);
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(field.name)) {
      const newBuildingMaterialObject = field.name.filter(
        (name: string) => form.values[name] === true
      );

      if (
        JSON.stringify(newBuildingMaterialObject) !==
        JSON.stringify(buildingMaterialObject)
      ) {
        setBuildingMaterialObject(newBuildingMaterialObject);
      }
    } else if (form.values[field.name] !== buildingMaterialObject) {
      setBuildingMaterialObject(form.values[field.name] || "");
    }
  }, [form.values, field.name]);

  useEffect(() => {
    if (buildingMaterialObject) {
      if (Array.isArray(field.name)) {
        field.name.forEach((name: string) => {
          if (form.values[name] !== buildingMaterialObject.includes(name)) {
            form.setFieldValue(name, buildingMaterialObject.includes(name));
          }
        });
      } else if (form.values[field.name] !== buildingMaterialObject) {
        form.setFieldValue(field.name, buildingMaterialObject);
      }
    }
  }, [buildingMaterialObject]);

  return (
    <div className="building-material-component">
      <div className="am-section-heading">
        {label}
        {optional && <span> (opcjonalne)</span>}
      </div>
      <div
        className={`am-section-checkbox-list construction-site__list ${
          half ? "construction-site__list--half" : ""
        }`}
      >
        {options.map((item: any) => {
          const isChecked = Array.isArray(buildingMaterialObject)
            ? buildingMaterialObject.includes(item.value)
            : buildingMaterialObject === item.value;

          return (
            <CheckboxPart
              className="radiobox"
              onChange={() => handleCheckMaterial(item)}
              checked={isChecked}
              key={item.value}
              label={item.label}
              uuid={item.value}
            />
          );
        })}
      </div>
      {errors && form.touched && (
        <>
          <StaticAlert
            className="am-alert"
            size="small"
            show={errors[field.name] && errors[field.name]}
            label="Te dane są obowiązkowe. Uzupełnij je, aby móc przejść dalej."
          />
        </>
      )}
      <div className="am-separator" />
    </div>
  );
};

export default TypeOfRadiobox;
